import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import '../../../../styles/RegDashboard.css';
import { HHIEButton } from '../../../utility/HHIEButton';

export function POCRegistrationModal(props) {
    const [user, setUser] = useState(null);
    const [pocIsFullyRegistered, setPOCIsFullyRegistered] = useState();

    useEffect(() => {
        setUser(props.user);
        setPOCIsFullyRegistered(props.pocIsFullyRegistered);
    }, []);

    return (
        <Modal
            show={!pocIsFullyRegistered}
            size="lg"
            centered
        >
            <Modal.Header>
                <Modal.Title id="contained-modal-title-vcenter">
                    Complete Registration
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>
                    In order to continue using this system, you must fill out any required vital information. Click the button below to do so.
                </p>
            </Modal.Body>
            <Modal.Footer>
                <HHIEButton
                    id="complete-reg-btn"
                    title="Complete Registration"
                    onClick={
                        () => {
                            fetch('api/POCUser/retrieve-member-info/' + user.sfid)
                                .then(response => {
                                    response.json()
                                        .then((pocMember) => {
                                            if (pocMember.errors !== null && pocMember.errors !== "") alert(pocMember.errors)
                                            sessionStorage.setItem("member", JSON.stringify(pocMember.message));
                                            window.location.href = "/member-form";
                                        })
                                })
                        }
                    }
                />
            </Modal.Footer>
        </Modal>
    );
}
